import { useSettings } from '../interfaces/Settings'
import { useHints as useDennemeyerHints } from '../dennemeyer/Hints'

export function useHints() {
  const { implementation } = useSettings()
  const { hint, isHintNeeded } = useDennemeyerHints()

  if (implementation === 'dennemeyer') {
    return { hint, isHintNeeded }
  } else {
    return { hint: null, isHintNeeded: false }
  }
}
